import {integrityProfGralSpac} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadIntegrityProfGralSpac(selection: any) {
  return useLoad(
    integrityProfGralSpac,
    ['iD_ProfGral', 'iD_ProfileSpac'],
    selection,
  );
}

export default useLoadIntegrityProfGralSpac;
